'use strict';

angular.module('error', [
    'ui.router',
    'sharecrf-sdk',
]);
